import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, API } from "../../../api";

export default function InventoryValuationSummary() {
  const [getReport, { data, loading }] = useLazyQuery(
    API.GET_INVENTORY_VALUATION_SUMMARY,
    { fetchPolicy: "network-only" }
  );

  React.useEffect(() => {
    getReport();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      name: "code",
      label: "Product Code",
      options: { align: "center" },
    },
    {
      name: "description",
      label: "Customer Description",
      options: { align: "left", width: 400 },
    },
    {
      name: "stockOnHand",
      label: "Stock On Hand",
      options: { align: "center" },
    },
    {
      name: "assetValue",
      label: "Inventory Asset Value",
      options: { align: "right", money: true, showTotal: true },
    },
  ];

  return (
    <Report title="Inventory Valuation Summary" data={data} columns={columns}>
      <Table data={data} columns={columns} showTotals isLoading={loading} />
    </Report>
  );
}
